// Health question rules shared by PersonalQuestionaire and DependentInfo
// (same behaviour as the common-enrollment HealthInfo tab):
//  1. "Are you still on medication?" on a condition sets Taking Medication and
//     Current Treatment to Yes, and clears + disables Date of Recovery (not required).
//  2. If any answered condition has Taking Medication = Yes, the medication question
//     is forced to Yes and locked. When that stops being true it goes back to No,
//     but only if it was forced (a Yes the member chose stays).
// The "still on medication" flag is UI-only; the backend drops it.

// Medication questions currently forced to Yes. Not reactive on purpose: it only
// decides whether to revert to No.
const forcedYes = new WeakSet();

const emptyMedication = () => ({ medication: '', dosage: '', medical_condition: '' });

function conditionsOf(question) {
    return (question && question.conditions) || [];
}

export default {
    methods: {
        isStillOnMedication(condition) {
            return !!condition && condition.is_still_on_medication == 1;
        },

        setStillOnMedication(condition, checked) {
            this.$set(condition, 'is_still_on_medication', checked ? 1 : 0);
            if (checked) {
                condition.is_medicate = '1';
                condition.is_treatment = '1';
                this.$set(condition, 'date_of_recovery', null);
            }
        },

        // Not stored by the backend: Taking Medication with no recovery date means still on it.
        initStillOnMedication(healthInfo) {
            ((healthInfo && healthInfo.condition_questions) || []).forEach((question) => {
                conditionsOf(question).forEach((condition) => {
                    const still = condition.is_medicate == 1 && !condition.date_of_recovery;
                    this.$set(condition, 'is_still_on_medication', still ? 1 : 0);
                });
            });
        },

        isMedicationAutoEnabled(healthInfo) {
            return ((healthInfo && healthInfo.condition_questions) || []).some((question) =>
                question.selected_answer == 1 && conditionsOf(question).some((condition) => condition.is_medicate == 1)
            );
        },

        // Idempotent, so it is safe to call from a deep watcher.
        syncMedicationQuestion(healthInfo) {
            const medicationQuestion = healthInfo && healthInfo.medication_question;
            if (!medicationQuestion || medicationQuestion.question_id === undefined) return;

            if (this.isMedicationAutoEnabled(healthInfo)) {
                forcedYes.add(medicationQuestion);
                if (medicationQuestion.selected_answer != 1) {
                    this.$set(medicationQuestion, 'selected_answer', '1');
                }
                if (!Array.isArray(medicationQuestion.medications)) {
                    this.$set(medicationQuestion, 'medications', []);
                }
                if (!medicationQuestion.medications.length) {
                    medicationQuestion.medications.push(emptyMedication());
                }
            } else if (forcedYes.has(medicationQuestion)) {
                forcedYes.delete(medicationQuestion);
                this.$set(medicationQuestion, 'selected_answer', '0');
                this.$set(medicationQuestion, 'medications', []);
            }
        },
    },
};
